import { atom } from "jotai";
import { ArtifactMediaData } from "../../../tanstackQuery/queries/artifacts/type";

const INITIAL_ARTIFACT_IN_ATOM_VALUE: ArtifactMediaData = {
  note: {},
  media: {},
  transcript: {},
  video: {},
  metaAnalysis : {}
};

export const artifactAtom = atom<ArtifactMediaData>(
  INITIAL_ARTIFACT_IN_ATOM_VALUE
);

export const setArtifactAtom = (set: Function, value: ArtifactMediaData) => {
  set(artifactAtom, value);
};